import { render, staticRenderFns } from "./PublisherFile.vue?vue&type=template&id=4ccb6a37&scoped=true"
import script from "./PublisherFile.vue?vue&type=script&lang=js"
export * from "./PublisherFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb6a37",
  null
  
)

export default component.exports